import { render, staticRenderFns } from "./AutoSelection.vue?vue&type=template&id=36fa0091&scoped=true"
import script from "./AutoSelection.vue?vue&type=script&lang=js"
export * from "./AutoSelection.vue?vue&type=script&lang=js"
import style0 from "./AutoSelection.vue?vue&type=style&index=0&id=36fa0091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa0091",
  null
  
)

export default component.exports